var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglePlayMark = function SvgGooglePlayMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "30 10 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 10.5997C30.1 10.8997 30 11.3997 30 11.9997V34.0997C30 34.6997 30.2 35.1997 30.5 35.4997L30.6 35.5997L43 23.1997V22.9997L30.4 10.5997Z",
    fill: "url(#googlePlayMarkGradientA)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0004 27.3999L42.9004 23.2999V22.9999L47.0004 18.8999L47.1004 18.9999L52.0004 21.7999C53.4004 22.5999 53.4004 23.8999 52.0004 24.6999L47.0004 27.3999Z",
    fill: "url(#googlePlayMarkGradientB)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0994 27.2999L42.8994 23.0999L30.3994 35.5999C30.8994 36.0999 31.5994 36.0999 32.4994 35.6999L47.0994 27.2999Z",
    fill: "url(#googlePlayMarkGradientC)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0994 18.9001L32.4994 10.6001C31.5994 10.1001 30.8994 10.2001 30.3994 10.7001L42.8994 23.1001L47.0994 18.9001Z",
    fill: "url(#googlePlayMarkGradientD)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "googlePlayMarkGradientA",
    x1: 41.8,
    y1: 11.8097,
    x2: 25.017,
    y2: 28.5917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googlePlayMarkGradientB",
    x1: 53.8344,
    y1: 23.1009,
    x2: 29.6374,
    y2: 23.1009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googlePlayMarkGradientC",
    x1: 44.8264,
    y1: 25.3959,
    x2: 22.0684,
    y2: 48.1539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googlePlayMarkGradientD",
    x1: 27.2964,
    y1: 3.27609,
    x2: 37.4594,
    y2: 13.4391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
};
export default SvgGooglePlayMark;